import styled from '@emotion/styled';
import { css } from 'twin.macro';
import React from 'react';
import { BsPencil, BsTrash } from 'react-icons/bs';
import { ActionStyles } from '../../../../../reusableStyles';
import { ToolTip } from '../../../../../../../_elements/ToolTip';

function CategoryItem({ category, handleEdit, handleDelete }) {
	let tag;
	if (category?.isPremium) {
		tag = <span>Premium (only for admins to assign)</span>;
	} else if (category?.isManagerial) {
		tag = <span>Managerial</span>;
	} else {
		tag = <span>Normal</span>;
	}
	return (
		<StyledCategoryItem className="col-12 col-md-6">
			<div
				className="categoryContainer"
				css={css`
					border-left-color: ${category.isPremium ? '#50aeb0' : '#e0f0ef'} !important;
				`}
			>
				<div className="d-flex align-items-center">
					<img src={category?.pin} alt="category" className="category_icon" />
					<div className="ml-2 ">
						<div className="category_title">{category?.name}</div>
						<div className="category_special">{tag}</div>
					</div>
				</div>
				<div>
					<ActionStyles>
					<ToolTip text={'Edit'} side={'top'} cssStyles={"top:-70% !important; min-width: fit-content !important"}>
						<BsPencil className="icon" onClick={() => handleEdit(category)} />
						</ToolTip>
						<ToolTip text={'Delete'} side={'top'} cssStyles={"top:-70% !important; min-width: fit-content !important"}>
						<BsTrash className="icon delete" onClick={() => handleDelete(category._id)} />
						</ToolTip>
					</ActionStyles>
				</div>
			</div>
		</StyledCategoryItem>
	);
}

export default CategoryItem;

const StyledCategoryItem = styled.div`
	.categoryContainer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 25px;
		border-left: 5px solid;
		margin-right: 20px;
	}
	.category_icon {
		object-fit: contain;
		width: 70px;
		height: 70px;
		border-radius: 5px;
	}
`;
